module.exports = __webpack_public_path__ + "img/ic_permissions.3c51c673.png";